import React from "react";

function DownloadPDF2() {
    return(
        <div style={{ backgroundColor: '#3b82f6' }} className="text-white font-medium rounded-lg text-sm px-5 py-2.5 w-40 mt-3 flex justify-center mx-auto" >
            {/* <a href="harvard cv.pdf" download="Harvard CV & Cover Letter Document.pdf">Download</a> */}
            <a href="Harvard CV & Cover Letter Document.pdf" target="_blank" rel="noopener noreferrer">Download</a>
        </div>
    )
}
export default DownloadPDF2